module.exports = __webpack_public_path__ + "static/assets/9051e48fcb52c619b8eab0b1be11b4dc.svg";